
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"30","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 0C5.184 0 .453 4.731.453 10.547c0 1.964.544 3.882 1.573 5.545L10.4 29.584a.88.88 0 001.502-.012l8.16-13.622a10.548 10.548 0 001.486-5.403C21.547 4.73 16.816 0 11 0zm0 15.832c-2.95 0-5.285-2.401-5.285-5.285 0-2.908 2.377-5.285 5.285-5.285 2.908 0 5.285 2.377 5.285 5.285 0 2.858-2.304 5.285-5.285 5.285z"}})])
          )
        }
      }
    